/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteModelProviderKeySecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteModelProviderKeySecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteModelProviderKeySecurity = {
  option1?: DeleteModelProviderKeySecurityOption1 | undefined;
  option2?: DeleteModelProviderKeySecurityOption2 | undefined;
};

export type DeleteModelProviderKeyRequest = {
  /**
   * The ID of the key to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteModelProviderKeySecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteModelProviderKeySecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteModelProviderKeySecurityOption1$Outbound,
    DeleteModelProviderKeySecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteModelProviderKeySecurityOption1ToJSON(
  deleteModelProviderKeySecurityOption1: DeleteModelProviderKeySecurityOption1,
): string {
  return JSON.stringify(
    DeleteModelProviderKeySecurityOption1$outboundSchema.parse(
      deleteModelProviderKeySecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteModelProviderKeySecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteModelProviderKeySecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteModelProviderKeySecurityOption2$Outbound,
    DeleteModelProviderKeySecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteModelProviderKeySecurityOption2ToJSON(
  deleteModelProviderKeySecurityOption2: DeleteModelProviderKeySecurityOption2,
): string {
  return JSON.stringify(
    DeleteModelProviderKeySecurityOption2$outboundSchema.parse(
      deleteModelProviderKeySecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteModelProviderKeySecurity$Outbound = {
  Option1?: DeleteModelProviderKeySecurityOption1$Outbound | undefined;
  Option2?: DeleteModelProviderKeySecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteModelProviderKeySecurity$outboundSchema: z.ZodMiniType<
  DeleteModelProviderKeySecurity$Outbound,
  DeleteModelProviderKeySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteModelProviderKeySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteModelProviderKeySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteModelProviderKeySecurityToJSON(
  deleteModelProviderKeySecurity: DeleteModelProviderKeySecurity,
): string {
  return JSON.stringify(
    DeleteModelProviderKeySecurity$outboundSchema.parse(
      deleteModelProviderKeySecurity,
    ),
  );
}

/** @internal */
export type DeleteModelProviderKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteModelProviderKeyRequest$outboundSchema: z.ZodMiniType<
  DeleteModelProviderKeyRequest$Outbound,
  DeleteModelProviderKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteModelProviderKeyRequestToJSON(
  deleteModelProviderKeyRequest: DeleteModelProviderKeyRequest,
): string {
  return JSON.stringify(
    DeleteModelProviderKeyRequest$outboundSchema.parse(
      deleteModelProviderKeyRequest,
    ),
  );
}
